import { createBrowserUIEventBufferStorage } from './createBrowserUIEventBufferStorage';

/**
 * The tab's one queue, shared by the hook and logout. A single instance so the
 * hook's effect (and `online` listener) does not re-run every render, and
 * logout clears the same store. Tests pass an in-memory store.
 */
export const BROWSER_UI_EVENT_BUFFER_STORAGE =
  createBrowserUIEventBufferStorage();
